module.exports = __webpack_public_path__ + "static/media/logo-global.ec97d6b0.png";